// src/data.ts
var regions = {
  eu: {
    name: "eu",
    label: "EU",
    awsRegion: "eu-west-1",
    flag: "\u{1F1EA}\u{1F1FA}",
    geographicRegion: "Ireland"
  },
  us: {
    name: "us",
    label: "US",
    awsRegion: "us-east-1",
    flag: "\u{1F1FA}\u{1F1F8}",
    geographicRegion: "N. Virginia"
  }
};
var getRegionFromAWS = (awsRegion) => {
  return Object.keys(regions).find(
    (key) => regions[key].awsRegion === awsRegion
  );
};
var awsRegions = Object.keys(regions).map((key) => regions[key].awsRegion);
var activeRegions = ["eu", "us"];
function isActiveRegion(region) {
  return activeRegions.includes(region);
}
function currentRegion() {
  const { AWS_REGION } = process.env;
  if (!AWS_REGION) throw new Error("AWS_REGION not set");
  return Object.keys(regions).find(
    (key) => regions[key].awsRegion === AWS_REGION
  );
}
export {
  activeRegions,
  awsRegions,
  currentRegion,
  getRegionFromAWS,
  isActiveRegion,
  regions
};
